import RUF from "../../../util/redux";

export function downPaymentStatedBankCountSave(state, action) {
  return RUF.updateObject(state, {
    model: RUF.updateObject(state.model, {
      downPayment: RUF.updateObject(state.model.downPayment, {
        statedBankCount: action.payload
      })
    })
  });
}
